import { Amount, OrderDirection } from "@goodfill/domain-properties";
import { DateTime } from "luxon";
import { useState, useEffect } from "react";
import { Paper } from "../../../ui-components";
import { PricedBond } from "../PricedBond";
import { OrderFormState } from "../../order/orderForm/state/OrderFormState";
import { SimilarBonds } from "../similarBonds/SimilarBonds";
import { BondDetailBondParams } from "./BondDetailBondParams";
import { BondDetailBreadcrumbs } from "./BondDetailBreadcrumbs";
import { BondDetailHeader } from "./BondDetailHeader";
import { BondDetailSimulator } from "./BondDetailSimulator";
import { BondDetailCharts } from "./BondDetailCharts";
import { BondDetailMoreOnTheOffer } from "./moreAbout/BondDetailMoreOnTheOffer";
import { BondDetailAboutTheBid } from "./moreAbout/BondDetailAboutTheBid";
import { BondDetailTheWorks } from "./moreAbout/BondDetailTheWorks";
import { BondDetailInvestButton } from "./BondDetailInvestButton";
import "./BondDetail.scss";

interface Props {
  pricedBond: PricedBond;
  tradeDate: DateTime;
}

export const BondDetail: React.FC<Props> = ({ pricedBond, tradeDate }) => {
  const [state, setState] = useState<OrderFormState | undefined>();
  const onFaceAmountChange = (newFaceAmount: Amount) => {
    if (state == null) {
      return;
    }
    setState(state.withFaceAmount(newFaceAmount));
  };

  useEffect(() => {
    setState(OrderFormState.createDefault(OrderDirection.Buy, pricedBond, tradeDate, null, null));
  }, [tradeDate, pricedBond]);

  return (
    <>
      <BondDetailBreadcrumbs issuerName={pricedBond.issuerName} />
      <div className="flex flex-row w-full justify-start">
        <Paper>
          <div className="flex flex-col gap-16">
            <BondDetailHeader pricedBond={pricedBond} />
            <div className="md:px-16 sm:px-8 px-4 flex flex-col gap-16 mb-16">
              <div className="grid md:grid-cols-2 grid-cols-1 gap-8">
                <BondDetailBondParams pricedBond={pricedBond} tradeDate={tradeDate} />
                <BondDetailSimulator state={state} onFaceAmountChange={onFaceAmountChange} />
              </div>

              {state ? <BondDetailCharts state={state} pricedBond={pricedBond} /> : null}

              <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-8">
                <BondDetailMoreOnTheOffer pricedBond={pricedBond} className={"w-full"} />
                <BondDetailAboutTheBid pricedBond={pricedBond} className={"w-full"} />
                <BondDetailTheWorks pricedBond={pricedBond} className={"w-full"} />
              </div>
              <div className="flex flex-row w-full justify-center">
                <BondDetailInvestButton bondId={pricedBond.bondIdCusip} />
              </div>
            </div>
          </div>
        </Paper>
      </div>
      <SimilarBonds pricedBond={pricedBond} />
    </>
  );
};
